import { gsap } from 'gsap';
import { PARENT_FONT_SIZE_PX } from 'SharedConstants/renderer';
// import { handleKeyFrameActions } from 'Renderer/domOperations/actionOperations';

/* global store */
const CACHE_BUSTER_REGEX =
         /([CACHEBUSTER])|([timestamp])|({TIME})|({RANDOM})|(%n)|([random])/gi;
export const TAG_SELECTOR_PREFIX = 'ivo';
export const COMPONENT_SELECTOR_PREFIX = 'i';
export const ARTBOARD_WRAPPER_DOM_ID = `${COMPONENT_SELECTOR_PREFIX}-a-wrapper`;
export const ARTBOARD_BORDER_DOM_ID = `${COMPONENT_SELECTOR_PREFIX}-a-border`;

const caluculateLineHeight = (lineHeight, fontHeight) => `${Math.round(((parseInt(lineHeight, 10) / parseInt(fontHeight, 10)) * 100), 10)}%`;
const getPixelAsPercenatge = size => `${(Math.round((parseInt(size, 10) / PARENT_FONT_SIZE_PX) * 100))}%`;

const additionalProps = {
  scaleX: scaleX => (scaleX === 0 ? 0 : 1 / scaleX),
  scaleY: scaleY => (scaleY === 0 ? 0 : 1 / scaleY),
};

const getOverrideProps = tweenCSS => ({
  rotate: `${tweenCSS.rotate || 0}`,
  scale: `${tweenCSS.scale || 1}`,
});

export const makeSanitizedCSS = (tweenCSS) => {
  const lineHeight = (tweenCSS.lineHeight && tweenCSS.fontSize);
  delete tweenCSS._gsap;
  delete tweenCSS.rotationZ;
  return {
    ...tweenCSS,
    ...(lineHeight && { lineHeight: caluculateLineHeight(tweenCSS.lineHeight, tweenCSS.fontSize) }),
    ...(tweenCSS.fontSize && { fontSize: getPixelAsPercenatge(tweenCSS.fontSize) }),
  };
};

const setDefaults = (animationData) => {
  const { rootElement } = store.getState();
  const tweenTargets = [...new Set(animationData.map(t => t.target))];
  tweenTargets.forEach((tweenTarget) => {
    const defaultTween = animationData.find(t => t.target === tweenTarget);
    const target = rootElement.querySelector(`#${defaultTween.target}`);
    const overrideProps = getOverrideProps(defaultTween.css);
    const sanitizedCSS = makeSanitizedCSS(defaultTween.css);
    gsap.set(target, { ...sanitizedCSS, modifiers: { ...(defaultTween.isGroupChild && additionalProps), overrideProps } });
  });
};

const handleActions = (handleKeyFrameActions, tween) => {
  if (tween) {
    if (tween.target.includes('-i')) return;
    const tweenActions = tween.actions ? tween.actions.keyFrameActions || [] : [];
    const hasActions = (tweenActions.length > 0);
    if (hasActions) handleKeyFrameActions(tween.actions);
  }
};

const createTween = (tween, handleKeyFrameActions) => {
  const { rootElement } = store.getState();
  const target = rootElement.querySelectorAll(`#${tween.target}`);
  const overrideProps = getOverrideProps(tween.css);
  const sanitizedCSS = makeSanitizedCSS(tween.css);

  return gsap.to(
    target,
    tween.duration, {
      ...sanitizedCSS,
      modifiers: {
        ...(tween.isGroupChild && additionalProps),
        ...overrideProps,
      },
      onComplete: handleActions,
      onCompleteParams: [handleKeyFrameActions, tween],
    },
  );
};

export const initialiseAnimation = (timeline, animationData, handleKeyFrameActions) => {
  // gsap.config({ force3D: true });
  // gsap.defaults({ ease: 'none' });
  // timeline.kill();
  // setDefaults(animationData);
  animationData.forEach((tween) => {
    timeline.add(
      createTween(tween, handleKeyFrameActions),
      tween.time,

    );
  });
};

export const replaceCacheBuster = url =>
  url.replace(CACHE_BUSTER_REGEX, Math.random() * 1e20);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Render/utils/importers.js